// put all types here
export enum EAPIMethods {
  GET = 'GET',
  POST = 'POST',
  PATCH = 'PATCH',
  PUT = 'PUT',
  DELETE = 'DELETE',
  HEAD = 'HEAD',
}

export interface IErrorResponse {
  error: string;
  message: string;
  programName: string;
}

export interface IUrlParams {
  method?: EAPIMethods;
  body?: Record<string, any>;
  headers?: Record<string, string> | Headers;
  endPoint?: boolean;
  formData?: FormData;
  s3Upload?: boolean;
  Response?: Response;
}

export interface ProgramPricingProfile {
  discount: number
  maxRetailPrice: number
}

export interface Program {
  id: number
  name: string
  product_id: number
  duration: string
  sub_headline: string
  description: string
  banner_image: string
  preferred_upsell_product_id: number
  demo_webinar_id: any
  booking_call_url: string
  buy_now_url: string
  apply_now_url: string
  preview_cohort_id: number
  brochure_url: string
  is_featured: boolean
  createdAt: string
  updatedAt: string
  preview_cohort_id_start_date: string
  mappedCohort_StartDate: string
  programBoosters: any
  programType: string
  instructors: Instructor[]
  // subIndustries: SubIndustry[]
  // industries: Industry[]
  sessions_type?: string
  pricingProfile?: ProgramPricingProfile
}

export enum SLPProgramType {
  MENTORSHIP = 'mentorship',
  SELFPACED = 'spc',
  WORKSHOP = 'workshop',
}

export interface Instructor {
  name: string
  designation: string
  brandName: string
  profilePhoto: string
}

export interface Mentor {
  id: number
  attributes: {
    name: string
    designation: string
    companyName: string
    mentorImage: StrapiImage
  }
}

// export interface SubIndustry {
//   subIndustry: string
//   isPrimarySubIndustry: boolean
// }

// export interface Industry {
//   id: number
//   industry: string
// }

export interface StrapiImage {
  data?: {
    attributes: {
      url: string
    }
  }
}

export interface Industry {
  id: number;
  attributes: {
    name: string;
    premium_subindustries: {
      data: SubIndustry[];
    },
    is_primary: boolean;
    size_in_billion: number;
    avg_salary_in_inr: number;
    jobs_in_market_curr_year: number;
  }
}

export interface SubIndustry {
  id: number;
  attributes: {
    name: string;
    standard_lps: {
      data: StandardLP[];
    },
    is_primary: boolean;
    size_in_billion: number;
    avg_salary_in_inr: number;
    jobs_in_market_curr_year: number;
  }
}

export interface StandardLP {
  id: number;
  attributes: {
    productId: number;
    banner_image: StrapiImage;
    name: string;
    sub_headline: string;
    premium_mentors: {
      data: Mentor[];
    },
    standard_lp_bonuses: {
      data: StandardLPBonus[];
    },
  },
}

export interface StandardLPBonus {
  id: number;
  attributes: {
    title: string;
    description: string;
  }
}

export interface IPApiResponse {
  ip: string;
  city: string;
  region: string;
  country: string;
  country_name: string;
  continent_code: string;
  in_eu: boolean;
  postal: string;
  latitude: number;
  longitude: number;
  timezone: string;
  utc_offset: string;
  country_calling_code: string;
  currency: string;
  languages: string;
  asn: string;
  org: string;
}